export interface AssistantRecentError {
  status: number;
  message: string;
  endpoint: string;
  method?: string;
  at: string;
}

export const ASSISTANT_ERROR_EVENT = 'klinvia-assistant-error';

const MAX_ERRORS = 5;
const MAX_MESSAGE_LENGTH = 500;

type Listener = (errors: AssistantRecentError[]) => void;

let buffer: AssistantRecentError[] = [];
const listeners = new Set<Listener>();

function notify(): void {
  const snapshot = getRecentErrors();
  listeners.forEach((listener) => {
    try {
      listener(snapshot);
    } catch {
      // listener com erro não pode quebrar o fluxo de respostas HTTP
    }
  });
}

export function getRecentErrors(): AssistantRecentError[] {
  return buffer.map((e) => ({ ...e }));
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function clearRecentErrors(): void {
  buffer = [];
  notify();
}

export function recordAssistantError(entry: AssistantRecentError): void {
  const normalized: AssistantRecentError = {
    status: entry.status,
    message: String(entry.message || '').slice(0, MAX_MESSAGE_LENGTH),
    endpoint: entry.endpoint,
    method: entry.method ? entry.method.toUpperCase() : undefined,
    at: entry.at,
  };
  buffer = [...buffer, normalized].slice(-MAX_ERRORS);
  notify();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent<AssistantRecentError>(ASSISTANT_ERROR_EVENT, { detail: normalized }));
  }
}

/** Caminho da API sem origem, sem query string e sem o prefixo /api/vN. */
export function toAssistantErrorEndpoint(url: string | undefined): string {
  let path = String(url || '').split('#')[0].split('?')[0];
  if (/^https?:\/\//i.test(path)) {
    try {
      path = new URL(path).pathname;
    } catch {
      path = '';
    }
  }
  path = path.replace(/^\/?api\/v\d+(?=\/|$)/i, '');
  if (!path.startsWith('/')) path = `/${path}`;
  return path;
}

export function isAssistantEndpoint(endpoint: string): boolean {
  return /^\/(support\/)?assistant(\/|$)/i.test(endpoint);
}
